module.exports = __webpack_public_path__ + "img/jordan.ed18a6b0.png";